import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Autocomplete,
  TextField,
} from '@mui/material';

export default function ClientAssignmentDialog({
  assignmentDialog,
  currentAssignmentClient,
  availableEmployees,
  selectedEmployee,
  onAssignmentDialogClose,
  onAssignClient,
  onSelectedEmployeeChange,
}) {
  return (
    <Dialog open={assignmentDialog} onClose={onAssignmentDialogClose} maxWidth="sm" fullWidth>
      <DialogTitle>{currentAssignmentClient?.assigned_employee ? 'Edit Assignment' : 'Assign Employee'}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Client: {currentAssignmentClient?.practice_name}
        </Typography>
        <Box sx={{ mt: 2 }}>
          <Autocomplete
            options={Array.isArray(availableEmployees) ? availableEmployees : []}
            getOptionLabel={(option) => `${option.full_name} - ${option.department} - ${option.designation}`}
            value={selectedEmployee}
            onChange={(event, newValue) => {
              onSelectedEmployeeChange(newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Employee"
                placeholder="Search employees..."
                variant="outlined"
                fullWidth
              />
            )}
            renderOption={(props, option) => (
              <Box component="li" {...props}>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography variant="body2">
                    {option.full_name} - {option.department} - {option.designation}
                  </Typography>
                </Box>
              </Box>
            )}
            noOptionsText="No employees available"
            fullWidth
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onAssignmentDialogClose}>Cancel</Button>
        <Button onClick={onAssignClient} variant="contained" disabled={!selectedEmployee}>
          {currentAssignmentClient?.assigned_employee ? 'Update Assignment' : 'Assign'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
